import type { ParamMatcher } from '@sveltejs/kit';

const opts = ['machine', 'monitor', 'edit', ''] as const;

export const match = ((param: string): param is (typeof opts)[number] => {
  return opts.includes(param as (typeof opts)[number]);
}) satisfies ParamMatcher;
